<template>
    <div>
        <div class="button-area">
            <Button @click="save()" :loading="saveLoading" type="primary" class="button-right-left">保存</Button>
            <Button @click="back()" class="button-right">返回</Button>
        </div>
        <div class="form-area">
            <Form style="width: 900px" :model="model" :label-width="110" label-position="left" inline>
                                <FormItem :class="{'model-hidden': true}" label="文本框">
                        <Input v-model="model.id"  type="text"></Input>
                    </FormItem>
                    <FormItem :class="{'model-hidden': true}" label="文本框">
                        <Input v-model="model.companyCode"  type="text"></Input>
                    </FormItem>
                    <FormItem :class="{'model-hidden': true}" label="文本框">
                        <Input v-model="model.isAbnormal"  type="text"></Input>
                    </FormItem>
                    <FormItem :class="{'model-hidden': true}" label="文本框">
                        <Input v-model="model.inspectionTime"  type="text"></Input>
                    </FormItem>
                    <FormItem :class="{'model-hidden': true}" label="文本框">
                        <Input v-model="model.createTime"  type="text"></Input>
                    </FormItem>
                    <FormItem :class="{'model-hidden': true}" label="文本框">
                        <Input v-model="model.jkhwWsbJzxh"  type="text"></Input>
                    </FormItem>
                    <FormItem :class="{'model-hidden': true}" label="文本框">
                        <Input v-model="model.jkhwWsbBgdh"  type="text"></Input>
                    </FormItem>
                    <FormItem :class="{'model-hidden': true}" label="文本框">
                        <Input v-model="model.jkhwWjcBgdh"  type="text"></Input>
                    </FormItem>
                    <FormItem :class="{'model-hidden': true}" label="文本框">
                        <Input v-model="model.jkhwWjcJzxh"  type="text"></Input>
                    </FormItem>
                    <FormItem :class="{'model-hidden': true}" label="文本框">
                        <Input v-model="model.jkhwWxdJzxh"  type="text"></Input>
                    </FormItem>
                    <FormItem :class="{'model-hidden': true}" label="文本框">
                        <Input v-model="model.jkhwWxdBgdh"  type="text"></Input>
                    </FormItem>
                    <FormItem :class="{'model-hidden': true}" label="文本框">
                        <Input v-model="model.userId"  type="text"></Input>
                    </FormItem>

            </Form>
        </div>
    </div>
</template>

<script>
    import util from '@/libs/util.js';

    export default {
        name: 'tqtNldcForm',
        data () {
            return {
                //ID
                id: null,
                saveLoading:false,
                //表单参数
                model: {
                        id: null,
                        companyCode: null,
                        isAbnormal: null,
                        inspectionTime: null,
                        createTime: null,
                        jkhwWsbJzxh: null,
                        jkhwWsbBgdh: null,
                        jkhwWjcBgdh: null,
                        jkhwWjcJzxh: null,
                        jkhwWxdJzxh: null,
                        jkhwWxdBgdh: null,
                        userId: null,
        }
        };
        },
        mounted () {
            if (typeof (this.$route.query.id) !== 'undefined' && this.$route.query.id !== null && this.$route.query.id !== '') {
                this.id = this.$route.query.id;
                //ID存在渲染表单
                this.initForm();
            }
        },
        methods: {
            //保存
            save () {
                if (this.id) {
                    this.update();
                } else {
                    this.create();
                }

            },

            create(){
                let _this = this;
                _this.saveLoading=true;
                util.ajax
                        .post("/api/tqtNldcs", this.model, {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        })
                        .then(function (response) {
                            _this.$Notice.success({
                                title: '保存成功!'
                            });
                            _this.back()
                        })
                        .catch(function (error) {
                            _this.$Notice.error({
                                title: '保存失败!'
                            });
                            _this.saveLoading=false;
                            console.log(error);
                        });
            },

            update(){
                let _this = this;
                _this.saveLoading=true;
                util.ajax
                        .put("/api/tqtNldcs", this.model, {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        })
                        .then(function (response) {
                            _this.$Notice.success({
                                title: '更新成功!'
                            });
                            _this.back()
                        })
                        .catch(function (error) {
                            _this.$Notice.error({
                                title: '更新失败!'
                            });
                            _this.saveLoading=false;
                            console.log(error);
                        });
            },



            //渲染表单
            initForm () {
                let _this = this;
                util.ajax
                        .get("/api/tqtNldcs/" + this.id, {
                            params: {}
                        })
                        .then(function (response) {
                            let tem = response.data;
                            _this.model.id=tem.id,
                            _this.model.companyCode=tem.companyCode,
                            _this.model.isAbnormal=tem.isAbnormal,
                            _this.model.inspectionTime=tem.inspectionTime,
                            _this.model.createTime=tem.createTime,
                            _this.model.jkhwWsbJzxh=tem.jkhwWsbJzxh,
                            _this.model.jkhwWsbBgdh=tem.jkhwWsbBgdh,
                            _this.model.jkhwWjcBgdh=tem.jkhwWjcBgdh,
                            _this.model.jkhwWjcJzxh=tem.jkhwWjcJzxh,
                            _this.model.jkhwWxdJzxh=tem.jkhwWxdJzxh,
                            _this.model.jkhwWxdBgdh=tem.jkhwWxdBgdh,
                            _this.model.userId=tem.userId
                        })
                        .catch(function (error) {
                            _this.$Notice.error({
                                title: '获取表单失败!'
                            });
                            console.log(error);
                        });
            },

            //返回,需要自定义配置路由
            back () {
                let _this = this;
                let tagName = _this.$route.name;
                _this.$store.commit("removeTag", tagName);
                _this.$store.commit("closePage", tagName);
                _this.$router.push({
                    name: "tqt_nldc"
                });
            }
        }
    };
</script>

<style scoped>
    .button-area {
        display: flex;
        justify-content: flex-end;
    }

    .button-right-left {
        margin-right: 15px;
    }

    .button-right {
        margin-right: 55px;
    }

    .form-area {
        margin-top: 40px;
        display: flex;
        justify-content: center;
    }

    .form-flex {
        display: flex;
        justify-content: space-between;
    }

    .model-hidden{
        display: none;
    }

</style>
